import {
  BILLBOARD_CADENCE_LABELS,
  currentBillboardPriceCents,
} from "../features/billboards/billboardDisplay";
import { BILLBOARD_SLOT_IDS } from "../services/billboard-api/BillboardApi";
import { useBillboardStore } from "../stores/useBillboardStore";

function dollars(cents: number): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(cents / 100);
}

export function BillboardHud() {
  const enabled = useBillboardStore((state) => state.enabled);
  const slots = useBillboardStore((state) => state.slots);
  const serverOffsetMs = useBillboardStore((state) => state.serverOffsetMs);
  const open = useBillboardStore((state) => state.open);

  if (!enabled) return null;

  return (
    <nav className="billboard-hud" aria-label="Billboard takeovers">
      <span className="billboard-hud__label">TAKE OVER A BILLBOARD</span>
      <div>
        {BILLBOARD_SLOT_IDS.map((slotId) => {
          const slot = slots.find((candidate) => candidate.id === slotId);
          return (
            <button
              key={slotId}
              type="button"
              onClick={() => open(slotId)}
              aria-label={`Open ${BILLBOARD_CADENCE_LABELS[slotId].toLowerCase()} billboard${slot ? `, ${dollars(currentBillboardPriceCents(slot, serverOffsetMs))}` : ""}`}
            >
              <strong>{BILLBOARD_CADENCE_LABELS[slotId]}</strong>
              <span>
                {slot
                  ? dollars(currentBillboardPriceCents(slot, serverOffsetMs))
                  : "LOADING"}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
